import { isObject, copyObject } from '@/helpers/helpers'

class Model {
  _compareProperties (payload, cast) {
    const result = []
    Object.keys(cast).forEach(key => {
      if (!payload || !(key in payload)) result.push(key)
      if (isObject(cast[key])) {
        result.push(...this._compareProperties(payload[key], cast[key]))
      }
    })
    return result
  }

  _clearPayload (payload, cast) {
    Object.keys(payload).forEach(key => {
      if (!(key in cast)) delete payload[key]
      if (isObject(payload[key])) {
        this._clearPayload(payload[key], cast[key])
      }
    })
    return payload
  }

  preparePayloadByCast (payload, cast) {
    const difference = this._compareProperties(payload, cast)
    return difference.length === 0 ? this._clearPayload(copyObject(payload), cast) : false
  }
}

export default Model
